<!-- Menú full‐screen estilo “ART STGO” -->
<div
  class="fixed inset-0 z-50 flex items-center justify-center backdrop-blur-sm p-4"
>
  <div
    class="p-6 relative flex w-full max-h-[90%] max-w-xl flex-col overflow-auto rounded-2xl bg-black text-white shadow-xl gap-y-6"
  >
    <!-- Botón de Cerrar Modal -->
    <div
      (click)="closeModal()"
      class="absolute right-4 top-4 p-2 flex items-center rounded-full text-white hover:bg-gray-700 cursor-pointer"
    >
      <mat-icon fontIcon="close"></mat-icon>
    </div>

    <div class="flex flex-col space-y-4">
      <form (ngSubmit)="onSignIn()" class="mt-8" [formGroup]="signInForm">
        <div>
          <label for="email" class="mb-2 block text-sm text-neutral-200"
            >Correo</label
          >
          <input
            id="email"
            type="email"
            placeholder="hola@artstgo.cl"
            formControlName="email"
            class="w-full rounded border border-neutral-700 bg-neutral-800 px-4 py-3 text-white focus:outline-none focus:ring-2 focus:ring-primary-300"
          />
        </div>
        <div>
          <label for="password" class="mb-2 mt-2 block text-sm text-neutral-200"
            >Contraseña</label
          >
          <input
            id="password"
            type="password"
            formControlName="password"
            placeholder="********"
            class="w-full rounded border border-neutral-700 bg-neutral-800 px-4 py-3 text-white focus:outline-none focus:ring-2 focus:ring-primary-300"
          />
          <a
            href="#"
            class="mt-2 block text-sm text-primary-300 hover:underline"
            >¿Olvidaste tu contraseña?</a
          >
        </div>
        <button
          type="submit"
          (click)="onSignIn()"
          [disabled]="signInForm.invalid || loadingSignInEmail"
          class="mt-6 w-full rounded bg-primary-300 py-3 text-center font-medium text-neutral-900 transition hover:bg-primary-400 disabled:cursor-not-allowed disabled:bg-neutral-700 disabled:text-neutral-500 flex items-center justify-center"
        >
          <!-- Spinner mientras carga -->
          @if(loadingSignInEmail){
          <svg
            class="h-5 w-5 animate-spin mr-2 text-neutral-900"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              class="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              stroke-width="4"
            ></circle>
            <path
              class="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8v8H4z"
            ></path>
          </svg>
          <span>Cargando…</span>
          }@else {Iniciar sesión}
        </button>
      </form>

      <div class="my-6 flex items-center justify-center text-neutral-500">
        <span class="h-px flex-1 bg-neutral-700"></span>
        <span class="px-3">O</span>
        <span class="h-px flex-1 bg-neutral-700"></span>
      </div>
      <button
        [disabled]="loadingSignInApple"
        (click)="onSignInWithApple()"
        class="disabled:cursor-not-allowed disabled:bg-neutral-700 disabled:text-neutral-500 w-full border-neutral-700 bg-transparent py-3 text-center font-medium text-white transition hover:bg-neutral-800 flex items-center justify-center"
      >
        @if(loadingSignInApple){
        <svg
          class="h-5 w-5 animate-spin mr-2 text-neutral-900"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
        >
          <circle
            class="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            stroke-width="4"
          ></circle>
          <path
            class="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8v8H4z"
          ></path>
        </svg>
        <span>Cargando…</span>
        }@else {Continuar con Apple}
      </button>
      <button
        (click)="onSignInWithGoogle()"
        [disabled]="loadingSignInGoogle"
        class="disabled:cursor-not-allowed disabled:bg-neutral-700 disabled:text-neutral-500 w-full border-neutral-700 bg-transparent py-3 text-center font-medium text-white transition hover:bg-neutral-800 flex items-center justify-center"
      >
        @if (loadingSignInGoogle) {
        <svg
          class="h-5 w-5 animate-spin mr-2 text-neutral-900"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
        >
          <circle
            class="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            stroke-width="4"
          ></circle>
          <path
            class="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8v8H4z"
          ></path>
        </svg>
        <span>Cargando…</span>
        }@else {Continuar con Google}
      </button>
    </div>
  </div>
</div>
